import { render, staticRenderFns } from "./registerInvite.vue?vue&type=template&id=b7a8d0e0&scoped=true"
import script from "./registerInvite.vue?vue&type=script&lang=js"
export * from "./registerInvite.vue?vue&type=script&lang=js"
import style0 from "./registerInvite.vue?vue&type=style&index=0&id=b7a8d0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a8d0e0",
  null
  
)

export default component.exports